module.exports = __webpack_public_path__ + "img/HA.7c04ebc5.png";